import {restoreService} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../service-keys";

export function restoreServiceMutationOptions() {
  return mutationOptions({
    mutationKey: serviceMutationKeys.restoreService,
    mutationFn: (id: string) => restoreService(id),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: serviceKeys.all});
    },
  });
}
